document.addEventListener("DOMContentLoaded", function() {
  initBackToTop();

  window.addEventListener("klaviyoForms", function(e) {
    const { type, formId } = e.detail;

    const targetFormIds = ["WjbUT8", "XLvwXF", "Vp5AZ6"];
    if (type === "embedOpen" && targetFormIds.includes(formId)) {
      onKlaviyoFormOpen(formId);
    }
  });

  // Traducir pop-up de Klaviyo (solo si está en español o italiano)
  if (isPortugueseLanguage() || isItalianLanguage() || isEnglishLanguage()) {
    translateKlaviyoPopup();
    // Traducir botón "NOTIFY ME WHEN AVAILABLE"
    translateNotifyButton();
  }
});

function initBackToTop() {
  const backToTop = document.getElementById("back-to-top");
  if (!backToTop) return;

  function toggleBackToTop() {
    const scrollPos = window.scrollY || document.documentElement.scrollTop;
    const pageHeight = document.documentElement.scrollHeight - window.innerHeight;

    if (scrollPos > pageHeight * 0.1) {
      backToTop.classList.add("show");
    } else {
      backToTop.classList.remove("show");
    }
  }

  window.addEventListener("scroll", toggleBackToTop);

  backToTop.addEventListener("click", () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
}

function getCurrentLanguage() {
  const lang = document.documentElement.lang || document.documentElement.getAttribute('lang') || '';
  return lang.toLowerCase();
} 

function isPortugueseLanguage() {
  const lang = getCurrentLanguage();
  return lang.startsWith('pt');
}

function isItalianLanguage() {
  const lang = getCurrentLanguage();
  return lang.startsWith('it');
}

function isEnglishLanguage() {
  const lang = getCurrentLanguage();
  return lang.startsWith('en');
}

function needsTranslation() {
  return isPortugueseLanguage() || isItalianLanguage() || isEnglishLanguage();
}

function translateKlaviyoPopup() {
  // Traducciones por idioma
  const translations = {
    pt: {
      "Avísame cuando vuelva a estar disponible": "Avise-me quando disponível novamente",
      "Te enviaremos un correo electrónico cuando este producto vuelva a estar disponible.": "Enviaremos um e-mail quando este produto estiver novamente em estoque.",
      "Introduce tu email": "Digite seu e-mail",
      "Email": "Email",
      "Quiero suscribirme también.": "Eu também quero me inscrever.",
      "¡AVÍSAME!": "AVISE!",
      "Close dialog": "Fechar diálogo",
      "*Al suscribirte aceptas recibir mensajes de Marketing Promocional.": "*Ao se inscrever, você concorda em receber mensagens de Marketing Promocional.",
      "¡Listo!": "Preparado!",
      "Te avisaremos cunado vuelva a estar disponible.": "Avisaremos quando estiver disponível novamente.",
      "VOLVER A LA COLECCIÓN": "VOLTAR À COLEÇÃO"
    },
    it: {
      "Avísame cuando vuelva a estar disponible": "Fammi sapere quando sarà di nuovo disponibile.",
      "Te enviaremos un correo electrónico cuando este producto vuelva a estar disponible.": "Ti invieremo un'email non appena questo prodotto sarà nuovamente disponibile.",
      "Introduce tu email": "Inserisci il tuo indirizzo email",
      "Email": "Email",
      "Quiero suscribirme también.": "Vorrei abbonarmi anch'io.",
      "¡AVÍSAME!": "FAMMI SAPERE!",
      "Close dialog": "Chiudi dialogo",
      "*Al suscribirte aceptas recibir mensajes de Marketing Promocional.": "*Iscrivendoti, accetti di ricevere messaggi di Marketing Promozionale.",
      "¡Listo!": "Pronto!",
      "Te avisaremos cunado vuelva a estar disponible.": "Vi avviseremo quando sarà nuovamente disponibile.",
      "VOLVER A LA COLECCIÓN": "TORNA ALLA COLLEZIONE"
    },
    en: {
      "Avísame cuando vuelva a estar disponible": "Let me know when it's available again.",
      "Te enviaremos un correo electrónico cuando este producto vuelva a estar disponible.": "We will send you an email when this product is back in stock.",
      "Introduce tu email": "Enter your email",
      "Email": "Email",
      "Quiero suscribirme también.": "I want to subscribe too.",
      "¡AVÍSAME!": "LET ME KNOW!",
      "Close dialog": "Close dialog",
      "*Al suscribirte aceptas recibir mensajes de Marketing Promocional.": "*By subscribing you agree to receive Promotional Marketing messages.",
      "¡Listo!": "Ready!",
      "Te avisaremos cunado vuelva a estar disponible.": "We'll let you know when it's available again.",
      "VOLVER A LA COLECCIÓN": "BACK TO COLLECTION"
    }
  };

  // Obtener el idioma actual
  const currentLang = isPortugueseLanguage() ? 'pt' : isItalianLanguage() ? 'it' : isEnglishLanguage() ? 'en' : null;
  if (!currentLang) return;

  const langTranslations = translations[currentLang];

  // Función para traducir los textos del pop-up
  function translatePopupTexts(popupElement) {
    if (!popupElement || !needsTranslation()) return;

    // Traducir placeholder del email
    const emailInput = popupElement.querySelector('input[type="email"]');
    if (emailInput && emailInput.placeholder === "Introduce tu email") {
      emailInput.placeholder = langTranslations["Introduce tu email"];
    }

    // Traducir texto del checkbox
    const checkboxLabel = popupElement.querySelector('label[for^="opt_in_promotional_email"]');
    if (checkboxLabel) {
      const labelText = checkboxLabel.querySelector('div');
      if (labelText && labelText.textContent.trim() === "Quiero suscribirme también.") {
        labelText.textContent = langTranslations["Quiero suscribirme también."];
      }
    }

    // Traducir todos los botones
    const buttons = popupElement.querySelectorAll('button[type="button"]');
    buttons.forEach(function(button) {
      const buttonText = button.textContent.trim();
      if (buttonText === "¡AVÍSAME!") {
        button.textContent = langTranslations["¡AVÍSAME!"];
      } else if (buttonText === "VOLVER A LA COLECCIÓN") {
        button.textContent = langTranslations["VOLVER A LA COLECCIÓN"];
      }
    });

    // Traducir todos los títulos h1
    const titleElements = popupElement.querySelectorAll('h1 span');
    titleElements.forEach(function(titleElement) {
      const titleText = titleElement.textContent.trim();
      if ( titleText === "Avísame cuando vuelva a estar disponible") {
        titleElement.textContent = langTranslations["Avísame cuando vuelva a estar disponible"];
      } else if (titleText === "¡Listo!") {
        titleElement.textContent = langTranslations["¡Listo!"];
      }
    });

    // Traducir todos los párrafos
    const paragraphElements = popupElement.querySelectorAll('div');
    paragraphElements.forEach(function(paragraphElement) {
      const paragraphText = paragraphElement.textContent.trim();
      if (paragraphText === "Te enviaremos un correo electrónico cuando este producto vuelva a estar disponible.") {
        paragraphElement.textContent = langTranslations["Te enviaremos un correo electrónico cuando este producto vuelva a estar disponible."];
        paragraphElement.style.display = "flex";
        paragraphElement.style.flexDirection = "column";
        paragraphElement.style.padding = "8px 0px 25px";
        paragraphElement.style.justifyContent = "center";
        paragraphElement.style.alignItems = "center";
        paragraphElement.style.textAlign = "center";
        paragraphElement.style.fontSize = "14px";
        paragraphElement.style.margin = "0 3px";
      } else if (paragraphText === "Te avisaremos cunado vuelva a estar disponible.") {
        paragraphElement.textContent = langTranslations["Te avisaremos cunado vuelva a estar disponible."];
        paragraphElement.style.flexDirection = "column";
        paragraphElement.style.padding = "8px 0px 13px";
        paragraphElement.style.justifyContent = "center";
        paragraphElement.style.alignItems = "center";
        paragraphElement.style.textAlign = "center";
        paragraphElement.style.fontSize = "14px";
        paragraphElement.style.margin = "0 3px";
      }
    });

    //Traducir condiciones
    const conditionElements = popupElement.querySelectorAll('div span');
    conditionElements.forEach(function(conditionElement) {
      const conditionText = conditionElement.textContent.trim();
      if ( conditionText === "*Al suscribirte aceptas recibir mensajes de Marketing Promocional.") {
        conditionElement.textContent = langTranslations["*Al suscribirte aceptas recibir mensajes de Marketing Promocional."];
      }
    });
    
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Buscar el pop-up de Klaviyo
          const popup = node.querySelector && node.querySelector('[role="dialog"][aria-label="POPUP Form"]');
          if (popup) {
            // Esperar un momento para que el contenido se renderice completamente
            setTimeout(() => {
              translatePopupTexts(popup);
            }, 100);
          }
          
          // También verificar si el nodo agregado es el pop-up mismo
          if (node.getAttribute && node.getAttribute('role') === 'dialog' && node.getAttribute('aria-label') === 'POPUP Form') {
            setTimeout(() => {
              translatePopupTexts(node);
            }, 100);
          }
        }
      });

      // Observar cambios en el contenido del formulario (cuando cambia a pantalla de confirmación)
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const popup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
        if (popup) {
          setTimeout(() => {
            translatePopupTexts(popup);
          }, 100);
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setTimeout(() => {
    const existingPopup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
    if (existingPopup) {
      translatePopupTexts(existingPopup);
    }
  }, 500);

  // Escuchar eventos de Klaviyo para detectar cuando se abre el pop-up o cambia el contenido
  window.addEventListener("klaviyoForms", function(e) {
    const { type } = e.detail;
    if (type === "embedOpen" || type === "open" || type === "submit" || type === "success") {
      setTimeout(() => {
        const popup = document.querySelector('[role="dialog"][aria-label="POPUP Form"]');
        if (popup) {
          translatePopupTexts(popup);
        }
      }, 300);
    }
  });

  const formObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const klaviyoForm = document.querySelector('form[data-testid^="klaviyo-form-"]');
        if (klaviyoForm) {
          const popup = klaviyoForm.closest('[role="dialog"]');
          if (popup) {
            setTimeout(() => {
              translatePopupTexts(popup);
            }, 100);
          }
        }
      }
    });
  });

  
  const checkAndObserveForms = function() {
    const klaviyoForms = document.querySelectorAll('form[data-testid^="klaviyo-form-"]');
    klaviyoForms.forEach(function(form) {
      formObserver.observe(form, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  };

  // Verificar formularios periódicamente
  setInterval(checkAndObserveForms, 1000);
  checkAndObserveForms();
}

function translateNotifyButton() {
  if (!needsTranslation()) return;
  
  const buttonTranslations = {
    pt: "AVISE-ME QUANDO ESTIVER DISPONÍVEL",
    it: "AVVISAMI QUANDO È DISPONIBILE",
    en: "LET ME KNOW WHEN IT'S AVAILABLE"
  };
  
  const currentLang = isPortugueseLanguage() ? 'pt' : isItalianLanguage() ? 'it' : isEnglishLanguage() ? 'en' : null;
  if (!currentLang) return;
  
  const translatedText = buttonTranslations[currentLang];
  
  function translateButton() {
    if (!needsTranslation()) return;
    const buttons = document.querySelectorAll('button[data-a11y-identifier^="bis-button"]');
    buttons.forEach(function(button) {
      if (button.textContent.trim() === "AVÍSAME CUANDO ESTÉ DISPONIBLE") {
        button.textContent = translatedText;
      }
    });
    
    const allButtons = document.querySelectorAll('button');
    allButtons.forEach(function(button) {
      if (button.textContent.trim() === "AVÍSAME CUANDO ESTÉ DISPONIBLE") {
        button.textContent = translatedText;
      }
    });
  }

  translateButton();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (!needsTranslation()) return;
        if (node.nodeType === 1) { // Element node
          // Verificar si el nodo es el botón o contiene el botón
          if (node.tagName === 'BUTTON' && node.textContent && node.textContent.trim() === "AVÍSAME CUANDO ESTÉ DISPONIBLE") {
            node.textContent = translatedText;
          } else if (node.querySelector) {
            const button = node.querySelector('button[data-a11y-identifier^="bis-button"]');
            if (button && button.textContent.trim() === "AVÍSAME CUANDO ESTÉ DISPONIBLE") {
              button.textContent = translatedText;
            }
          }
        }
      });
    });
    
    translateButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setInterval(translateButton, 1000);
}

